import * as React from "react";
import { forwardRef } from "react";
const SvgHeartbeat = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 18",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	stroke: "currentCOlor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	d: "M17.101 9.177 9.607 16.6l-2.894-2.866M.6 5.636a4.996 4.996 0 0 1 9.007-3.02A4.995 4.995 0 1 1 17.1 9.183M.613 8.606h1.999l1.998 2.998L6.61 5.608l1 2.998h2.997"
}));
const ForwardRef = forwardRef(SvgHeartbeat);
export default ForwardRef;
